import styled from 'styled-components';
export default styled.div.withConfig({
  displayName: "Container",
  componentId: "pgc0bz-0"
})(["display:block;width:100%;height:auto;position:relative;background-color:", ";"], function (_ref) {
  var theme = _ref.theme;
  return theme.backgroundColor || 'transparent';
});